import React, { useState } from 'react';
import 'swiper/css';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow, Autoplay } from 'swiper/modules';

import 'swiper/css/effect-coverflow';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import VideoPlay from './VideoPlay';
import { useSelector } from 'react-redux';

const Video = () => {
  const eventData = useSelector((state) => state.event.eventData);
  const video = eventData.invitation;
  const videourl = eventData.invitation.Records || [];
  const background = eventData.invitation.imageKey;

  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selecteddata, setSelectedData] = useState("");
console.log("video",video)
const handleOpenPopup = (url, data) => {
  console.log("url",url)
  console.log("url",url)
  setSelectedVideo(url);
  setSelectedData(data);
};
   
  return (
    <div>
        <section class="tour-area position-relative bg-top-center overflow-hidden space" id="service-sec"
 style={{
    backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${background})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
  
   >
 
 <div class="container" >
     <div class="row">
         <div class="col-lg-6 offset-lg-3" >
             <div class="title-area text-center">
                 <h2 class="sec-title">{video.subTitle}</h2>
                 <span class="sub-title">{video.title}</span>
             </div>
           
         </div>
     </div>
     
 </div>

</section>
    <section className="position-relative overflow-hidden space-bottom" id="destination-sec">
      <div className="container">
        <div className="title-area text-center">
          <span className="sub-title">Videos</span>
        </div>
        <div className="row gy-4 gx-4">
  {videourl
    .flat()                      // Flatten nested arrays
    .filter(Boolean)            // Remove nulls or undefined
    .map((video, index) => {
      const getVideoId = (url) => {
        const match = url.match(/(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
        return match ? match[1] : null;
      };

      const thumbnail = getVideoId(video.title)
        ? `https://img.youtube.com/vi/${getVideoId(video.title)}/mqdefault.jpg`
        : '';

      return (
        <div key={index} className="col-xl-3 col-lg-4 col-md-6">
          <div className="destination-item th-ani" style={{border:"1px solid gray"}}>
            <div className="destination-item_img global-img">
              <img src={thumbnail} alt={`video-${index}`} />
            </div>
            <div className="destination-content">
              <button
                className="th-btn style4 th-icon"
                onClick={() => handleOpenPopup(video.title, video.description)}
              >
                View
              </button>
            </div>
          </div>
        </div>
      );
    })}
</div>

      </div>
    </section>
  
    {selectedVideo && (
      <VideoPlay
      videoUrl={selectedVideo}
      data={selecteddata}
        onClose={() => setSelectedVideo(null)}
      />
    )}
  </div>
  )
}

export default Video